module.exports = __webpack_public_path__ + "static/fb-carousel-3cee1b1089a7e1b3fa499e7e8aeeacf3.jpg";